import { OrderSideEnum, OrderSideType } from '@flipster/apis/types';
import { ProductType } from '@flipster/apis/v2/history/types';

import { OrderSideBadge } from '../../misc/badge';

const mapping = {
  [ProductType.Perpetual]: {
    [OrderSideEnum.Buy]: 'Long',
    [OrderSideEnum.Sell]: 'Short',
  },
  [ProductType.Spot]: {
    [OrderSideEnum.Buy]: 'Buy',
    [OrderSideEnum.Sell]: 'Sell',
  },
} as const;

interface OrderSideBadgeProps {
  orderSide: OrderSideType;
  productType: ProductType;
}

export const HistoryOrderSideBadge = ({ orderSide, productType }: OrderSideBadgeProps) => {
  if (orderSide == OrderSideEnum.Invalid) return null;
  return <OrderSideBadge orderSide={mapping[productType][orderSide]} />;
};
